import { MapModalComponent } from './map-modal/map-modal.component';

export const CLINIC_COMPONENTS: any[] = [
  MapModalComponent
];
export * from './map-modal/map-modal.component';
